export default "__VITE_PUBLIC_ASSET__b24aacd2__"